const PLATFORM = {
  LOCAL: 'local',
  PRODUCTION: 'production',
  STAGING: 'staging'
};

module.exports = {
  PLATFORM,
  SENTRY_AUTH: process.env.SENTRY_AUTH_TOKEN,
  SENTRY_DSN: 'https://b642dd08db9c4abf9b7789ce07b37d91@sentry.io/1326130'
};
